// extracted by mini-css-extract-plugin
export default {"productTileProductHero":"productTileProductHero_ANcmA"};